import { IconButton, Stack, Badge, Popover, Box, TextField, MenuItem } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useEffect, useState } from "react";
import apiCNP from "../services/apiCNP";


export default function MunicipioFilter(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [municipios, setMunicipios] = useState([]);
  const open = Boolean(anchorEl);
  const [openSelect, setOpenSelect] = useState(true);
  const onClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (props?.provinciaId) {
      apiCNP.get(`/municipios-by-provincia/${props?.provinciaId}`)
        .then(res => {
          setMunicipios(res.data.municipios);
        }).catch(err => console.log(err))
    }
  }, [props?.provinciaId]);


  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <IconButton
        size="small"
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
          setOpenSelect(!openSelect);
        }}
      >
        <Badge
          color="primary"
          variant="dot"
          invisible={!props.municipio}
        >
          <FilterListIcon fontSize="small" />
        </Badge>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box p={2} minWidth={220}>
          <TextField
            type="text"
            label="Filtro por municipio"
            select
            style={{ width: 200 }}
            size="small"
            name="municipio"
            variant="outlined"
            onChange={(e) =>
              props?.setMunicipio(e.target.value === "Geral" ? "" : e.target.value)
            }
            SelectProps={{
              open: openSelect,
              onOpen: () => setOpenSelect(true),
              onClose: () => setOpenSelect(false),
            }}
            value={props.municipio}
          >
            <MenuItem value="Geral">Geral</MenuItem>
            {municipios?.map((municipio) => (
              <MenuItem key={municipio._id} value={municipio?.designacao} >
                {municipio.designacao}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </Popover>
    </Stack>
  );
};


